/**
 * TASK-951 — today's saved hours when a shop has no Google place id.
 * Shops with a place id keep the Google hours string.
 */

const DAY_KEYS = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

function formatTime24(time24) {
  const [hours, minutes] = String(time24 || '').split(':');
  const hour = parseInt(hours, 10);
  if (Number.isNaN(hour)) return '';
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  const mins = minutes || '00';
  return `${hour12}:${mins} ${ampm}`;
}

export function savedHoursTodayLabel(businessHours, now = new Date()) {
  if (!businessHours || typeof businessHours !== 'object') return null;
  const key = DAY_KEYS[now.getDay()];
  const dayData = businessHours[key];
  if (!dayData || typeof dayData !== 'object') return null;
  const dayName = key.charAt(0).toUpperCase() + key.slice(1);
  if (dayData.closed) return `${dayName}: Closed`;
  if (!dayData.open || !dayData.close) return null;
  const open = formatTime24(dayData.open);
  const close = formatTime24(dayData.close);
  if (!open || !close) return null;
  return `${dayName}: ${open} - ${close}`;
}

/** Pin text. Null means hours unavailable. */
export function pinHoursText(shop, hoursToday, now = new Date()) {
  if (shop?.place_id) {
    return hoursToday?.[shop.place_id] || null;
  }
  return savedHoursTodayLabel(shop?.business_hours, now);
}

/** List cards wait for Google when a place id exists. */
export function listShowsHours(shop, hoursToday) {
  if (!shop?.place_id) return true;
  return hoursToday?.[shop.place_id] !== undefined;
}
